import { WifiScanWifiItem } from "@robotical/ricjs";
import SimpleButton from "../../../../components/disposables/buttons/SimpleButton";
import { ConfigurationComponentType } from "../../../../navigation/ConfigurationNavigator";
import styles from "./styles.module.css";
import { useEffect, useState } from "react";
import WifiList from "../../../../components/disposables/WifiList";
import { useTranslation } from "react-i18next";

interface WifiConfStep1ScreenProps extends ConfigurationComponentType { };

export default function WifiConfStep1Screen({ currentScreenSetter }: WifiConfStep1ScreenProps) {
  const { t } = useTranslation();
  const [selectedWifi, setSelectedWifi] = useState<WifiScanWifiItem | undefined>(undefined);

  useEffect(() => {

  }, []);

  return (
    <div className={styles["wifi-conf-step-one-container"]}>
      <div>
        <p className={styles["wifi-conf-step-one-title"]}>{t("wifi_conf_step1.step", "STEP 1.")}</p>
        <p className={styles["wifi-conf-step-one-subtitle"]}>
          {t("wifi_conf_step1.which_network", "Which WiFi network should Marty connect to?")}
        </p>
        <p className={styles["wifi-conf-step-one-subtitle"]}>
          {t("wifi_conf_step1.only_24ghz", "Marty can only connect to 2.4GHz WiFi networks")}
        </p>
        <WifiList
          onItemPress={(item) => setSelectedWifi(item)}
          selectedWifiBssid={selectedWifi && selectedWifi.bssid}
        />
      </div>
      <div className={styles["wifi-conf-step-one-bottom-buttons-container"]}>
        <SimpleButton title={t("wifi_conf_step1.continue", "Continue")} disabled={!selectedWifi} onClick={() => currentScreenSetter("wifi-configuration-step-2", { ssid: selectedWifi?.ssid })} />
        <SimpleButton title={t("wifi_conf_step1.use_hidden", "Use a hidden or unlisted wifi network")} onClick={() => currentScreenSetter("wifi-configuration-step-1a")} />
      </div>
    </div>
  );
}
